import { render } from "./purchaseOrderList.vue?vue&type=template&id=0f5cd2b4&scoped=true"
import script from "./purchaseOrderList.vue?vue&type=script&lang=js"
export * from "./purchaseOrderList.vue?vue&type=script&lang=js"

import "./purchaseOrderList.vue?vue&type=style&index=0&id=0f5cd2b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f5cd2b4"

export default script